import styled from 'styled-components';
import { colors, Tag } from '@dexma/ui-components';

export const StyledDataAvailability = styled(Tag)`
    position: absolute;
    bottom: 1.2em;
    right: 1.2em;
    font-size: 11px;
    z-index: 2;
    background-color: ${colors.gray50};
    border: 1px solid ${colors.gray200};
`;
